import React, { Component } from 'react';
import moment from 'moment-timezone';
import { Timeline } from 'antd';
import Popup from 'components/common/Popup';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { StyledTimeline } from 'components/Styled';

const timelineLeft = {
  position: 'absolute',
  top: '0px',
  right: 'calc(100% + 8px)',
  width: '100%',
  textAlign: 'right'
};

const tags = {
  AvailableForPickup: {
    // backward compatibility
    color: '#502072'
  },
  'available-for-pickup': {
    color: '#502072'
  },
  cancel: {
    color: '#cccccc'
  },
  pending: {
    color: '#f09d78'
  },
  return: {
    color: '#ed3535'
  },
  'shipment-returned': {
    color: '#ed3535'
  },
  'first-mile-info-received': {
    color: '#2082c0'
  },
  'first-mile-delivered': {
    color: '#f0dd74'
  },
  'info-received': {
    color: '#f09d78'
  },
  'in-transit': {
    color: '#2082c0'
  },
  'out-for-delivery': {
    color: '#f0dd74'
  },
  'attempt-fail': {
    color: '#ba2ddb'
  },
  delivered: {
    color: '#57D7DD'
  },
  exception: {
    color: '#2C2C2E'
  },
  expired: {
    color: '#2C2C2E'
  },
  'parcel-scanned': {
    color: '#2082c0'
  }
};

const renderDot = (color, solid) => {
  return (
    <div
      style={{
        height: '10px',
        width: '10px',
        borderRadius: '99px',
        backgroundColor: solid ? color : 'transparent',
        border: `2px solid ${color}`
      }}></div>
  );
};

class CheckpointsTimeline extends Component {
  state = {};
  openStaticPopup = popups => {
    this.setState({
      popupKey: !this.state.popupKey,
      popups
    });
  };

  getFulfillmentPopup = () => {
    return [
      {
        id: 0,
        content: (
          <div
            style={{
              fontSize: '12px',
              padding: '20px 20px 10px',
              textAlign: 'center'
            }}>
            <div
              className="buttonTheme-color"
              style={{
                color: '#57D7DD',
                fontSize: '24px',
                padding: '10px 0 15px',
                fontWeight: 700
              }}>
              {this.props.t('popup.fulfillment_timeline_popup.title')}
            </div>
            <div
              style={{
                textAlign: this.props.t('key') === 'en' ? 'justify' : 'center'
              }}
              dangerouslySetInnerHTML={{
                __html: this.props.t('popup.fulfillment_timeline_popup.body')
              }}></div>
          </div>
        )
      }
    ];
  };

  render() {
    return (
      <StyledTimeline reverse={true}>
        {this.props.checkpoints.map(r => {
          return (
            <Timeline.Item
              dot={renderDot(tags[r.tag].color)}
              key={r.checkpointTime}>
              <div>
                <span style={{ fontSize: '12px' }}>
                  <span>{this.props.t(`transactions.tags.${r.tag}`)}</span>
                  {r.tag === 'first-mile-delivered' ? (
                    <span
                      className="buttonSecond-color"
                      style={{
                        color: '#57D7DD',
                        paddingLeft: '3px',
                        cursor: 'pointer',
                        lineHeight: '20px'
                      }}
                      onClick={() => {
                        this.openStaticPopup(this.getFulfillmentPopup());
                      }}>
                      <FontAwesomeIcon icon="info-circle" />
                    </span>
                  ) : (
                    ''
                  )}
                  <br />
                  {r.message}
                  {r.location ? (
                    <React.Fragment>
                      <br />
                      <span style={{ fontSize: '10px', color: '#2C2C2E' }}>
                        {r.location}
                      </span>
                    </React.Fragment>
                  ) : null}
                </span>
              </div>
              <div style={{ ...timelineLeft }}>
                <span style={{ fontSize: '12px' }}>
                  {moment(r.checkpointTime).format('MMM D, YYYY')}
                </span>
                <br />
                <span style={{ fontSize: '10px', color: '#2C2C2E' }}>
                  {moment
                    .tz(r.checkpointTime, moment.tz.guess())
                    .format('h:mm a z')}
                </span>
              </div>
            </Timeline.Item>
          );
        })}
        {this.props.status === -1 && (
          <Timeline.Item dot={renderDot(tags.cancel.color, true)}>
            <div>
              <span style={{ fontSize: '12px' }}>
                <span style={{ color: 'inherit' }}>
                  {this.props.t('transactions.tags.cancel')}
                </span>
                <br />
                {this.props.t('transactions.cancel')}
              </span>
            </div>
            <div style={{ ...timelineLeft }}>
              <span style={{ fontSize: '12px' }}>
                {moment(this.props.lastUpdate).format('MMM D, YYYY')}
              </span>
              <br />
              <span style={{ fontSize: '10px', color: '#2C2C2E' }}>
                {moment
                  .tz(this.props.lastUpdate, moment.tz.guess())
                  .format('h:mm a z')}
              </span>
            </div>
          </Timeline.Item>
        )}
        {this.state.popups && (
          <Popup key={!!this.state.popupKey} popups={this.state.popups} />
        )}
      </StyledTimeline>
    );
  }
}

export default CheckpointsTimeline;
